var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 98.831,
    xmlns: "http://www.w3.org/2000/svg",
    height: 96.047,
    id: "screenshot-4c13bd60-082e-80ca-8002-4429d03fb5e5",
    viewBox: "-6.541 -26.047 98.831 96.047",
    style: {
      WebkitPrintColorAdjust: "exact"
    },
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-4c13bd60-082e-80ca-8002-4429d03fb5e5",
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-4c13bd60-082e-80ca-8002-4429d03fb5e7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-4c13bd60-082e-80ca-8002-4429d03fb5e7"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M89.180,12.712C89.216,12.816,89.251,12.919,89.287,13.023L89.180,12.712ZM48.236,70.000L47.419,70.000C30.888,69.687,16.607,60.146,9.570,46.338L19.019,43.818C24.657,53.621,35.269,60.233,47.419,60.233L47.419,69.992M89.263,13.023L89.263,13.023ZM91.568,26.860L91.568,26.860Z",
    style: {
      fill: "rgb(30, 41, 59)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-4c13bd60-082e-80ca-8002-4429d03fb5e8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-4c13bd60-082e-80ca-8002-4429d03fb5e8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 11.44594594594605,
    ry: 11.395348837208985,
    cx: 11.44594594594605,
    cy: 21.16279069767461,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "rgb(30, 41, 59)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-4c13bd60-082e-80ca-8002-4429d03fb5e9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-4c13bd60-082e-80ca-8002-4429d03fb5e9"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M58.865,0.000C70.597,0.000,80.122,9.483,80.122,21.163L80.122,42.326L70.311,42.326L70.311,38.995C67.006,41.103,63.078,42.326,58.865,42.326C47.133,42.326,37.608,32.843,37.608,21.163C37.608,9.483,47.133,0.000,58.865,0.000ZM58.865,9.767C52.548,9.767,47.419,14.874,47.419,21.163C47.419,27.452,52.548,32.558,58.865,32.558C65.182,32.558,70.311,27.452,70.311,21.163C70.311,14.874,65.182,9.767,58.865,9.767Z",
    style: {
      fill: "rgb(30, 41, 59)",
      fillOpacity: 1
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBw);
export default __webpack_public_path__ + "static/media/logo-bw.e71a322820f20aaa2cf5ee75857ea160.svg";
export { ForwardRef as ReactComponent };